module.exports = __webpack_public_path__ + "img/shopeepay_logo.5d5455c6.svg";